import React, { useState, useEffect } from 'react'

import { Button, Form, Steps, Spin, Upload, Table, message } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'
import { PaperClipOutlined, TableOutlined } from '@ant-design/icons'

import { validRule, RULES } from '../../constants/Entitlements'
import injectValidationMethods from '../../util/checkValidation'
import enums from '../../util/enums'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'

const { Step } = Steps
const { Dragger } = Upload

const CreateDataLoads = function ({
  history,
  localId,
  setIsModalLocationVisible,
  currentStep,
  idTipoCarga,
  salvarArquivo
}) {
  const compState = {
    current: currentStep,
    formValues: {},
    showLoadingOnLocationForm: false,
    salvarArquivo: salvarArquivo
  }

  const [state, setState] = useState(compState)
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState([])

  // Params url
  const idLocation = localId

  // Mount/Unmount
  useEffect(() => {
    const hasAccess = validRule(RULES.DATALOAD) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
  }, [])

  const previewFile = async (file) => {
    try {
      const response = await request(api.getPreviewFromFileDataLoad(file.originFileObj, idTipoCarga))
      file.status = 'done'
      const formattedItems = response.map((item) => ({
        ...item
      }))
      setPreview(formattedItems)
    } catch (e) {
      file.status = 'error'
    } finally {
      setFileList([file])
    }
  }

  const props = {
    name: 'file',
    multiple: false,

    onError: (info) => {
      if (!info) {
        message.error(info)
      }
    },

    onChange: (info) => {
      if (info.file.status === 'removed') {
        setFileList([])
        return false
      }
      if (
        !info.file ||
        (info.file &&
          (info.file.status === 'error' || !(info.file.type === 'text/csv') || info.file.size > 2 * 1024 * 1024))
      ) {
        setFileList([])
        message.error(`Erro ao carregar arquivo.`)
      } else if (info.file.status === 'uploading') {
        let newFile = info.file
        if (newFile.response) {
          newFile.url = newFile.response.url
        }
        previewFile(newFile)
      }
    },
    onDrop() {
      setPreview([])
      setFileList([])
      setState({ ...state, current: 0 })
    }
  }

  const exportOptions = () => {
    if (idTipoCarga === 1) {
      window.open(process.env.REACT_APP_URL_TEMPLATE_CARGA_DADOS_PONTUACAO_AGRICULTORES)
    } else if (idTipoCarga === 2) {
      window.open(process.env.REACT_APP_URL_TEMPLATE_CARGA_DADOS_ACOES_EXECUTADAS)
    }
  }

  const removeFileList = () => {
    setFileList([])
    return true
  }

  function getPreviewColumns() {
    var value,
      columns = []
    if (preview.length > 0) {
      for (value of Object.keys(preview[0])) {
        var item = { key: value, title: value, dataIndex: value }
        columns.push(item)
      }
    }
    return columns
  }

  const form = {
    initialValues: state.formValues,
    yupValidationCreate: yup.object().shape({}),
    yupValidationUpdate: yup.object().shape({}),
    onSubmit: async () => {}
  }

  const yupValidation = !idLocation ? form.yupValidationCreate : form.yupValidationUpdate

  function renderFiles() {
    return (
      <Spin style={{ color: 'red' }} spinning={state.showLoadingOnLocationForm}>
        <hr style={{ fontWeight: 'bold' }} />
        <div style={{ marginBottom: '9%' }}>
          <Button
            type="dashed"
            className="button-action"
            style={{ float: 'right' }}
            onClick={exportOptions}
            target="_blank"
          >
            <TableOutlined color="white" /> Exportar Modelo
          </Button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', width: '75%', marginLeft: '12.5%', marginTop: '5%' }}>
          <Dragger
            {...props}
            accept=".csv"
            fileList={fileList}
            style={{ marginBottom: '5%', padding: '20px' }}
            onRemove={removeFileList}
          >
            <p className="ant-upload-text" style={{ marginBottom: '12px', fontWeight: 'bold' }}>
              Selecione um arquivo para importação.
            </p>
            <p className="ant-upload-hint" style={{ marginBottom: '12px' }}>
              Somente arquivos.csv e no formato do modelo disponibilizado.
            </p>

            <Button type="dashed" className="button-action">
              <PaperClipOutlined color="white" /> Selecionar
            </Button>
          </Dragger>
          <div style={{ width: '210%' }}></div>
        </div>
      </Spin>
    )
  }

  function renderPreview() {
    return (
      <>
        <hr style={{ fontWeight: 'bold' }} />
        <Table
          key="id_preview"
          dataSource={preview}
          columns={getPreviewColumns()}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
      </>
    )
  }
  function saveFile() {
    state.salvarArquivo(fileList[0].originFileObj, idTipoCarga)
  }

  function renderSent() {
    return (
      <div className="default-text">
        <hr style={{ fontWeight: 'bold' }} />
        <div style={{ padding: '90px 0' }}>
          <h3>O arquivo de importação foi enviado e já está sendo processado pelo sistema.</h3>
          <br />
          <p>
            <b style={{ color: '#E21D45' }}>Atenção:</b> Caso ocorra alguma falha no processo, voce poderá visualizar em
            detalhes todos os problemas encontrados com seu arquivo de dados, clicando no <b>status da importação</b>. O
            arquivo deverá ser totalmente corrigido e posteriomente reenviado em uma nova tentativa.
          </p>
        </div>
      </div>
    )
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={yupValidation}
        initialValues={state.formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, handleSubmit }) => {
          injectValidationMethods(values, yupValidation)
          const { customerLocationTypeOfDocument } = values
          if (customerLocationTypeOfDocument) {
            const { mask } = enums.find((docType) => docType.value === customerLocationTypeOfDocument)
            if (mask) {
              documentTypeMask = mask
            }
          }

          const hasAccess = idLocation === null ? validRule(RULES.DATALOAD) : validRule(RULES.DATALOAD)

          const steps = [
            {
              title: getMessage('files'),
              content: renderFiles()
            },
            {
              title: getMessage('preview'),
              content: renderPreview()
            },
            {
              title: getMessage('sent'),
              content: renderSent()
            }
          ]

          const hasFile = () => {
            return !!fileList.length && fileList[0].status === 'done'
          }

          const onDrop = () => {
            setIsModalLocationVisible()
            removeFileList()
            if (state.current === 1) {
              setState({ ...state, current: state.current - 1 })
            }
            if (state.current === 2) {
              setState({ ...state, current: state.current - 2 })
            }
          }

          const onChangeStep = (current) => {
            if (hasFile()) {
              setState({ ...state, current })
            }
          }

          return (
            <Form className="login-form" layout="vertical" onSubmit={handleSubmit}>
              <>
                <Steps
                  className="custome-step"
                  style={{ width: '50%', marginLeft: '25%' }}
                  onChange={onChangeStep}
                  current={state.current}
                >
                  {steps.map((item) => (
                    <Step key={item.title} title={item.title} />
                  ))}
                </Steps>
                <div className="steps-content">{steps[state.current].content}</div>
                <div className="horizontal-line"></div>
                <div
                  style={{
                    flex: 1,
                    justifyContent: 'flex-end',
                    flexDirection: 'row',
                    display: 'flex',
                    marginTop: '2%'
                  }}
                >
                  {state.current !== 0 && state.current !== 2 && (
                    <Button
                      style={{
                        width: '15%',
                        borderColor: '#EE778F',
                        color: '#EE778F'
                      }}
                      type="ghost"
                      onClick={() => setState({ ...state, current: state.current - 1 })}
                    >
                      {getMessage('back')}
                    </Button>
                  )}
                  {state.current === 2 && (
                    <Button
                      style={{
                        width: '15%',
                        borderColor: '#EE778F',
                        color: '#EE778F'
                      }}
                      type="ghost"
                      onClick={onDrop}
                    >
                      {getMessage('close')}
                    </Button>
                  )}
                  {hasAccess && state.current === 0 && (
                    <Button
                      type="ghost"
                      className="button-return"
                      style={{ borderColor: '#b58bfa', color: '#b58bfa' }}
                      onClick={onDrop}
                    >
                      {getMessage('cancel')}
                    </Button>
                  )}
                  {state.current === 0 && hasFile() && (
                    <Button
                      type="dashed"
                      className="button-action"
                      onClick={() => {
                        setState({ ...state, current: state.current + 1 })
                      }}
                    >
                      {getMessage('next')}
                    </Button>
                  )}
                  {state.current === 1 && hasFile() && (
                    <Button
                      type="primary"
                      className="button-action"
                      onClick={() => {
                        saveFile()
                        setState({ ...state, current: state.current + 1 })
                      }}
                    >
                      {getMessage('send')}
                    </Button>
                  )}
                </div>
              </>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default CreateDataLoads
